import { type ActionEvent, Controller } from "@hotwired/stimulus"

import DrawerController from "@/controllers/drawer_controller"
import { StimulusDispatchOptions } from "@/entry_points/types"
import { startPageLoader } from "@/helpers/page_loader"

export default class SearchFormController extends Controller {
  static outlets = ["drawer"]
  declare readonly drawerOutlets: DrawerController[]

  static targets = ["dateInput", "experienceInput", "locationInput", "locationSummary"]
  declare readonly dateInputTarget: HTMLInputElement
  declare readonly experienceInputTarget: HTMLInputElement
  declare readonly locationInputTarget: HTMLInputElement
  declare readonly locationSummaryTarget: HTMLElement
  declare readonly hasLocationSummaryTarget: boolean

  blurInput({ target }: ActionEvent): void {
    ;(target as HTMLElement).blur()
  }

  clearLocationSummary(): void {
    this.setLocationSummary("Any")
  }

  focusLocation({ detail }: StimulusDispatchOptions): void {
    ;(detail!.drawer as DrawerController).afterTransition(() => this.locationInputTarget.focus())
  }

  startLoader(): void {
    startPageLoader()
  }

  toDateStep({ params: { locationName } }: ActionEvent): void {
    this.setLocationSummary(locationName)

    if (this.dateDrawer) {
      this.dateDrawer.open()
    } else {
      this.dateInputTarget.focus()
    }
  }

  private get dateDrawer(): DrawerController | undefined {
    return this.drawerFor("[data-controller=search-date]")
  }

  private drawerFor(searchInputControllerSelector: string): DrawerController | undefined {
    return this.drawerOutlets.find(
      (drawer) => !!drawer.element.querySelector(searchInputControllerSelector)
    )
  }

  private setLocationSummary(text: string): void {
    if (this.hasLocationSummaryTarget) {
      this.locationSummaryTarget.textContent = text
    }
  }
}
